import ActionTypes from '../actions/types'

/**
 * Separate Redux slice for sister building data (residents, units, occupancies, staff).
 * This data is used specifically for amenities and events features where
 * residents from sister buildings may book shared amenities.
 *
 * This keeps sister building data separate from the main Residents/Units/Occupancies/Staff
 * reducers which should only contain data for the active building.
 */
const initialState = {
  residentsLookup: {},
  unitsLookup: {},
  occupanciesLookup: {},
  staffLookup: {},
  isLoaded: false,
}

// --------------------------------------------------------------------------------
// State mutation functions:

function loadSisterBuildingData(state, {residents, units, occupancies, staff}) {
  const residentsLookup = residents.reduce((acc, r) => {
    acc[r.id] = r
    return acc
  }, {})

  const unitsLookup = units.reduce((acc, u) => {
    acc[u.id] = u
    return acc
  }, {})

  const occupanciesLookup = occupancies.reduce((acc, o) => {
    acc[o.id] = o
    return acc
  }, {})

  // Staff lookup uses staffId from the BuildingStaff object
  const staffLookup = (staff || []).reduce((acc, bS) => {
    acc[bS.staffId] = {
      ...bS.staff,
      isDisabled: bS.isDisabled,
    }
    return acc
  }, {})

  return {
    ...state,
    residentsLookup,
    unitsLookup,
    occupanciesLookup,
    staffLookup,
    isLoaded: true,
  }
}

// --------------------------------------------------------------------------------

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.BUILDINGS_SET_VIEWING:
      // Clear sister building data when switching buildings
      return {...initialState}

    case ActionTypes.SISTER_BUILDING_DATA_LOAD_ALL:
      return loadSisterBuildingData(state, action.payload)

    case ActionTypes.SISTER_BUILDING_DATA_CLEAR:
      return {...initialState}

    default:
      return state
  }
}
